export const GOV_DYNAMIC_CONFIG_NAMES = {
  // Batch size the dashboard splits Bulk Update Access restriction writes into
  // (GOV-3348). Oso Cloud 413s above its own batch size, so a testing
  // workspace can lower this to exercise batching with a smaller dataset
  // during DVM validation. The write API keeps the DEFAULT_BULK_RESTRICTIONS
  // ceiling, so a lower value here only makes the client batch smaller.
  // Value shape: {limit: number}.
  BULK_RESTRICTIONS_LIMIT: 'dc-gov-3348-bulk-restrictions-limit',
} as const;
